import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentCallbackPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);
  const [message, setMessage] = useState("Processing your payment...");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const statusCode = queryParams.get("statusCode");

    if (statusCode) {
      if (statusCode === "SPG-0000") {
        setMessage("Payment successful. Redirecting...");
        setTimeout(() => {
          navigate("/payment-success");
        }, 2000);
      } else {
        setMessage("Payment failed or pending. Redirecting...");
        setTimeout(() => {
          navigate("/payment-failure");
        }, 2000);
      }
    } else {
      setMessage("Invalid response received.");
      setTimeout(() => {
        navigate("/payment-failure");
      }, 2000);
    }

    setProcessing(false);
  }, [location, navigate]);

  return (
    <div>
      <h1>Payment Callback</h1>
      {processing ? (
        <p>Please wait while we process your payment...</p>
      ) : (
        <p>{message}</p>
      )}
    </div>
  );
};

export default PaymentCallbackPage;
